import React from 'react'

export const CalendarIcon = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='33' height='36' viewBox='0 0 33 36'>
        <g fill='none' fill-rule='evenodd'>
          <g fill='url(#lvv422fjpa)' fill-rule='nonzero' stroke='url(#lvv422fjpa)'>
            <g>
              <path
                d='M30.253 2.545h-4.506V.636c0-.35-.288-.636-.644-.636-.355 0-.643.285-.643.636v1.91h-5.15V.635c0-.35-.288-.636-.643-.636-.356 0-.644.285-.644.636v1.91h-5.15V.635c0-.35-.288-.636-.643-.636-.355 0-.644.285-.644.636v1.91h-5.15V.635c0-.35-.288-.636-.643-.636-.355 0-.644.285-.644.636v1.91H.644c-.356 0-.644.285-.644.636v24.182c0 .35.288.636.644.636h29.609c.355 0 .644-.285.644-.636V3.182c0-.351-.289-.637-.644-.637zM5.149 3.818v.637c0 .35.289.636.644.636.355 0 .644-.285.644-.636v-.637h5.15v.637c0 .35.288.636.643.636.355 0 .644-.285.644-.636v-.637h5.149v.637c0 .35.288.636.644.636.355 0 .643-.285.643-.636v-.637h5.15v.637c0 .35.288.636.643.636.356 0 .644-.285.644-.636v-.637h3.862v3.818H1.287V3.818H5.15zm-3.862 22.91V8.908H29.61v17.818H1.287z'
                transform='translate(1 4)'
              />
            </g>
          </g>
        </g>
      </svg>
    );
}